<template>
    <section class="select-interior">
        <div class="configurator__container container">
            <StepBar step-name="Select your interior trim" :step="6" :steps="7" />

            <div class="configurator__flex-container">
                <div class="configurator__flex-left">
                    <Navigation :go-to-step="{ name: 'select-paint', params: { brand: brand, urlModel: urlModel }, query: { id: configuratorId } }" />

                    <ImageGallery />
                </div>

                <div class="configurator__flex-right">
                    <Card :title="model.model_title" description="Choose your interior:" :price="vehiclePricePlusPaint">
                        <LoadingSpinner v-if="loading"></LoadingSpinner>
                        <RadioButton v-else v-model="selectedInterior" id-key="id" value-key="value" price-key="price" :options="interiors" :show-prices="true" :has-info="true" @info-clicked="defineInfoAndOpenModal" />
                    </Card>

                    <div ref="continueButton" class="configurator__continue-btn-container">
                        <button class="btn btn--primary btn--min-width btn--full-width-xs" :class="{ 'btn--disabled': !interiorChoice }" :disbled="!interiorChoice" @click="nextStep">Continue</button>
                    </div>

                    <SaveConfiguration />
                </div>
            </div>
        </div>

        <OptionInfoModal v-if="optionInfo" :open="isModalVisible" :info="optionInfo" @close-option-info-modal="isModalVisible = false" />
    </section>
</template>

<script>
import EventObject from "../../modules/tracking/EventObject";
import { mapState } from "vuex";
import scrollToElement from "../modules/scrollToElement";
import OptionInfoModal from "../components/OptionInfoModal.vue";

export default {
    components: {
        OptionInfoModal,
    },
    props: {
        brand: {
            type: String,
            required: true,
        },
        urlModel: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            optionInfo: null,
            isModalVisible: false,
            loading: true,
        };
    },
    methods: {
        defineInfoAndOpenModal: function (option) {
            this.optionInfo = option;
            this.isModalVisible = true;
        },
        updateChoice: function (option) {},
        nextStep: function () {
            if (!this.interiorChoice) {
                return;
            }

            new EventObject("New Car - Configurator", "Next Step", "Clicked to Step 7 of 7: Personalise finance").dispatch();

            this.$router.push({
                name: "personalise-finance",
                params: { brand: this.brand, urlModel: this.urlModel },
                query: { id: this.configuratorId },
            });
        },
    },
    created() {
        this.$store.dispatch("getInteriors").then(() => {
            document.title = `${this.model.model_title} ${this.paint} | Configure My New ${this.manufacturer} Car`;

            this.$store.commit("setSelectedInteriorPrice", 0);
            this.$store.commit('updateFinanceRequests');

            if (this.interiors.length == 1) {
                this.selectedInterior = this.interiors[0].id;
            }

            this.loading = false;
        });
    },
    computed: {
        ...mapState(["model", "configuratorId", "availableInteriors", "paintOptions", "paintChoice", "manufacturer", "selectedVehiclePrice", "selectedPaintPrice", "interiorChoice"]),

        interiors() {
            return this.availableInteriors.map((interior) => {
                let value = interior.name.length > 25 ? interior.name.split("-")[0] : interior.name;
                return {
                    id: interior.id,
                    value,
                    price: interior.price,
                    info: [{ value, spec_name: interior.name }],
                };
            });
        },

        selectedInterior: {
            get: function () {
                return this.$store.state.interiorChoice;
            },
            set: function (selectedInteriorId) {
                for (let index = 0; index < this.interiors.length; index++) {
                    const selectedInterior = this.interiors[index];
                    if (selectedInterior.id != selectedInteriorId) {
                        continue;
                    }
                    this.$store.commit("setInteriorChoice", selectedInterior.id);
                    this.$store.commit("setSelectedInteriorPrice", selectedInterior.price);
                    this.$store.commit('updateFinanceRequests');
                    scrollToElement(this.$refs["continueButton"]);
                    return;
                }
            },
        },

        vehiclePricePlusPaint() {
            return Number(this.selectedVehiclePrice) + Number(this.selectedPaintPrice);
        },

        paint() {
            const paintOptionsLength = this.paintOptions.length;

            if (this.paintChoice == null) {
                return this.paintOptions[0].name;
            }

            for (let index = 0; index < paintOptionsLength; index++) {
                const paintOption = this.paintOptions[index];
                if (paintOption.id === this.paintChoice) {
                    return paintOption.name;
                }
            }

            return this.paintOptions[0].name;
        },
    },
};
</script>